module.exports = __webpack_public_path__ + "img/web-P4-1-3.d87646df.svg";